import { Box } from "@mui/material";
import VideoFileIcon from "@mui/icons-material/VideoFile";
import PlayCircleOutlineIcon from "@mui/icons-material/PlayCircleOutline";

export const styles = {
  VideoIconWithPlayButtonContainer: {
    position: "relative",
    width: 40,
    height: 40,
    display: "inline-flex",
    alignItems: "center",
    justifyContent: "center",
  },
};

export default function VideoIconWithPlayButton() {
  return (
    <Box sx={styles.VideoIconWithPlayButtonContainer}>
      <VideoFileIcon sx={{ fontSize: 40, color: "gray" }} />
      <span style={{ position: "absolute" }}>
        <PlayCircleOutlineIcon sx={{ fontSize: 30, color: "white" }} />
      </span>
    </Box>
  );
}
